import styled from '@emotion/styled'
import { Control, FieldErrors } from 'react-hook-form'
import { Colors } from '~/assets/style/colors'
import { Icon } from '~/components/Icon'
import { JSONEditorInput } from '~/components/JSONEditor'

const Footer = styled.div`
  width: 100%;
`

const Error = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${Colors.Alert};
`

export type CollapsiblePrebidModuleProps = {
  control: Control<{ jsonValue: string }>
  errors: FieldErrors<{ jsonValue: string }>
  isForbidden?: boolean
}

const BasePrebidModuleJsonForm = ({ control, errors, isForbidden }: CollapsiblePrebidModuleProps) => (
  <div>
    <JSONEditorInput control={control} name={'jsonValue'} disabled={isForbidden} />
    {errors.jsonValue?.message && (
      <Footer>
        <Error>
          <Icon width={'16px'} name={'alert'} />
          <span>{errors.jsonValue?.message}</span>
        </Error>
      </Footer>
    )}
  </div>
)

export const PrebidModuleJsonForm = BasePrebidModuleJsonForm
